import styled from 'styled-components'

export const CatalogItemContentStyled = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: ${(props) => props.theme.space.medium};
  min-width: 0;
  padding: ${(props) => props.theme.space.small};
`
